export type ShouldShowSetupChecklistParams = {
  accountCreatedAtMs: number | null;
  nowMs: number;
  dismissed: boolean;
  everComplete: boolean;
};

export const SETUP_CHECKLIST_WINDOW_MS = 14 * 24 * 60 * 60 * 1000;

export const shouldShowSetupChecklist = ({
  accountCreatedAtMs,
  nowMs,
  dismissed,
  everComplete,
}: ShouldShowSetupChecklistParams): boolean => {
  if (accountCreatedAtMs === null) {
    return false;
  }

  if (dismissed || everComplete) {
    return false;
  }

  return nowMs < accountCreatedAtMs + SETUP_CHECKLIST_WINDOW_MS;
};
